import React from 'react';
import { FaLinkedin, FaFacebook, FaInstagram } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="bg-[#e4e9f0] text-gray-800 text-sm pt-10 pb-6">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
        
        {/* Vänsterkolumn */}
        <div>
          <h2 className="font-semibold text-lg mb-2">Provalt Service AB</h2>
          <p className="mb-4">
            Med fokus på kvalitet, miljöansvar och kundnöjdhet erbjuder vi ett brett utbud av tjänster, 
            från diverse städtjänster till trädgårdsskötsel och underhåll.
          </p>
        <div className="flex justify-center md:justify-start gap-4 text-[#6b75e6] text-xl">
          <a href="https://www.linkedin.com/company/provalt-service-ab/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <FaLinkedin />
          </a>

          <a href="https://facebook.com/provaltserviceab" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <FaFacebook />
          </a>

          <a href="https://www.instagram.com/provalt.se/?igsh=MXNnamppa2o5c3Fqeg%3D%3D#" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <FaInstagram />
          </a>
        </div>

        </div>

        {/* Logotyp i mitten */}
        <div className="flex justify-center items-center">
          <img src="images/provalt-logo.png" alt="Provalt logo" className="h-36" />
        </div>

        {/* Högerkolumn med länkar och kontakt */}
        <div className="flex flex-col md:flex-row md:justify-between gap-6">
          <div>
            <h3 className="font-semibold mb-2">Länkar</h3>
            <ul className="space-y-1">
              <li><a href="/Arbetspolicy" className="hover:underline">Arbetspolicy</a></li>
              <li><a href="/integritetspolicy" className="hover:underline">Integritetspolicy</a></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold mb-2">Kontakt</h3>
            <p>E-post: info@provalt.se</p>
            <p>Provalt Service AB</p>
            <p>Org-nr: 559414–1565</p>
          </div>
        </div>
      </div>

      {/* Footer-bottom */}
      <div className="mt-10 text-center text-xs text-gray-600">
        Copyright © 2024 | Provalt.se
      </div>
    </footer>
  );
}

export default Footer;
